const adrTitleBarMenuV3 = {
  contentType: "adr",
  menuItems: [
    {
      _menuId: "adrTitleBarMenu_1",
      type: "TITLEBAR_MENU_ITEM",
      label: "Save",
      action: "saveDraft",
    },
    {
      _menuId: "adrTitleBarMenu_2",
      type: "TITLEBAR_MENU_ITEM",
      label: "Copy to Another Day",
      action: "copy",
    },
    {
      _menuId: "adrTitleBarMenu_3",
      type: "TITLEBAR_MENU_ITEM",
      label: "Print Preview",
      action: "print",
    },
    {
      _menuId: "adrTitleBarMenu_4",
      type: "TITLEBAR_MENU_ITEM",
      label: "Submit",
      action: "submit",
    },
    {
      _menuId: "adrTitleBarMenu_5",
      type: "TITLEBAR_MENU_SEPARATOR",
    },
    {
      _menuId: "adrTitleBarMenu_6",
      type: "TITLEBAR_MENU_ITEM",
      label: "Delete Diary",
      action: "delete",
    },
    {
      _menuId: "adrTitleBarMenu_7",
      type: "TITLEBAR_MENU_ITEM",
      label: "Close",
      action: "close",
    },
  ],
  toolbar: [
    {
      _iconId: "adrTitleBarToolbar_1",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "edit",
      toggleValue: "edit",
      action: "toggleEditMode",
      toolTipText: "Edit Mode",
      label: "Edit",
    },
    {
      _iconId: "adrTitleBarToolbar_2",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "glasses",
      toggleValue: "review",
      action: "toggleReviewMode",
      toolTipText: "Review Mode",
      label: "Review",
    },
    {
      _iconId: "adrTitleBarToolbar_3.separator",
      type: "TITLEBAR_TOOLBAR_SEPARATOR",
    },
    {
      _iconId: "adrTitleBarToolbar_4",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "save",
      action: "saveDraft",
      toolTipText: "Save Draft",
    },
    {
      _iconId: "adrTitleBarToolbar_5",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "eraser",
      action: "amend",
      toolTipText: "Amend Accepted Report",
    },
    {
      _iconId: "adrTitleBarToolbar_6",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "file-pdf",
      action: "printPdf",
      toolTipText: "Print Preview",
    },
    // {
    //   _iconId: "adrTitleBarToolbar_7",
    //   type: "TITLEBAR_TOOLBAR_ICON",
    //   icon: "download",
    //   action: "savePdf",
    //   toolTipText: "Save PDF",
    // },
    {
      _iconId: "adrTitleBarToolbar_8",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "clone",
      action: "copy",
      toolTipText: "Copy to Another Day",
    },
  ],
};

export default adrTitleBarMenuV3;
